import i18next from 'i18next';

// import type { DetailsPageProps, ViewPageProps } from 'app/main/components/page-layouts';
import type { AppRouteGroup } from 'app/store/components/NavigationUtils';
// import { lazyRetry } from 'app/main/components';

import en from './i18n/en';
import it from './i18n/it';

i18next.addResourceBundle('en', 'core', en);
i18next.addResourceBundle('it', 'core', it);

const routes: AppRouteGroup = {
	settings: {},
	routes: []
};

export default routes;
